import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import {classes} from '../../CartItem.st.css';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {Delete} from '@wix/wix-ui-icons-common/on-stage';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';

export interface RemoveProps {
  lineItem: LineItemModel;
  onItemRemoved?: () => void;
}

export const Remove = ({lineItem, onItemRemoved}: RemoveProps) => {
  const {t} = useTranslation();
  const {removeItemFromCart} = useControllerProps().cartStore;
  const handleRemoveItem = () => {
    removeItemFromCart(lineItem);
    onItemRemoved?.();
  };

  return (
    <button
      className={classes.remove}
      type="button"
      aria-label={t('cart.sr_remove_item_from_cart', {item_name: lineItem.name})}
      onClick={handleRemoveItem}
      data-hook={CartItemDataHook.Remove}>
      <Delete />
    </button>
  );
};
